import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';

import App from './containers/app';
import configureStore from './store/configureStore';
import registerServiceWorker from './registerServiceWorker';

Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });

const store = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js